module.exports = {
	"dashboard": {
		"name": "Dashboard",
		"path": "/",
		"value": "/",
		"icon": "fa fa-dashboard"
	},
	"page": {
		"name": "Pages",
		"path": "/pages",
		"value": "pages",
		"icon": "fa fa-pencil"
	},
	"menu": {
		"name": "Menus",
		"value": "menus",
		"icon": "fa fa-list-ul",
		"path": "/menus"
	},
	"banner": {
		"name": "Banners",
		"value": "banners",
		"icon": "fa fa-globe",
		"path": "/banners"
	},
	"storeLocator": {
		"name": "Store Locator",
		"value": "store-locator",
		"icon": "fa fa-location-arrow",
		"path": "/store-locator/stores"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/components/App/navigation.json
// module id = 2099
// module chunks = 0